import { Toaster } from "@/components/ui/toaster";
import { Toaster as Sonner } from "@/components/ui/sonner";
import { Routes, Route, BrowserRouter } from "react-router-dom";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { TooltipProvider } from "@radix-ui/react-tooltip";
import { DataProvider } from "@/contexts/DataContext";
import Layout from "@/components/Layout";
import Index from "@/pages/Index";
import IPOList from "@/pages/IPOList";
import IPODetail from "@/pages/IPODetail";
import IPOGmp from "@/pages/IPOGmp";
import NewsList from "@/pages/NewsList";
import NewsDetail from "@/pages/NewsDetail";
import JobsList from "@/pages/JobsList";
import JobsDetail from "@/pages/JobsDetail";
import Learning from "@/pages/Learning";
import LearningDetail from "@/pages/LearningDetail";
import Referral from "@/pages/Referral";
import NotFound from "@/pages/NotFound";
import AdminLogin from "./pages/admin/AdminLogin";
import AdminLayout from "./pages/admin/AdminLayout";
import AdminDashboard from "./pages/admin/AdminDashboard";
import AdminIPOs from "./pages/admin/AdminIPOs";
import AdminGmp from "./pages/admin/AdminGmp";
import AdminNews from "./pages/admin/AdminNews";
import AdminJobs from "./pages/admin/AdminJobs";
import AdminLearning from "./pages/admin/AdminLearning";
import AdminAffiliates from "./pages/admin/AdminAffiliates";
import AdminMarketTicker from "./pages/admin/AdminMarketTicker";
import Affiliated from "./pages/Affiliated";

const queryClient = new QueryClient();

const App = () => (
  <QueryClientProvider client={queryClient}>
    <TooltipProvider>
      <DataProvider>
        <Toaster />
        <Sonner />
        <BrowserRouter>
          <Routes>
            {/* Admin */}
            <Route path="/admin/login" element={<AdminLogin />} />
            <Route path="/admin" element={<AdminLayout />}>
              <Route index element={<AdminDashboard />} />
              <Route path="ipos" element={<AdminIPOs />} />
              <Route path="gmp" element={<AdminGmp />} />
              <Route path="news" element={<AdminNews />} />
              <Route path="jobs" element={<AdminJobs />} />
              <Route path="learning" element={<AdminLearning />} />
              <Route path="affiliates" element={<AdminAffiliates />} />
              <Route path="ticker" element={<AdminMarketTicker />} />
            </Route>

            {/* Public */}
            <Route path="/" element={<Layout><Index /></Layout>} />
            <Route path="/ipos" element={<Layout><IPOList /></Layout>} />
            <Route path="/ipos/:id" element={<Layout><IPODetail /></Layout>} />
            <Route path="/ipo-gmp" element={<Layout><IPOGmp /></Layout>} />
            <Route path="/news" element={<Layout><NewsList /></Layout>} />
            <Route path="/news/:id" element={<Layout><NewsDetail /></Layout>} />
            <Route path="/jobs" element={<Layout><JobsList /></Layout>} />
            <Route path="/jobs/:id" element={<Layout><JobsDetail /></Layout>} />
            <Route path="/learning" element={<Layout><Learning /></Layout>} />
            <Route path="/learning/:id" element={<Layout><LearningDetail /></Layout>} />
            <Route path="/referral" element={<Layout><Referral /></Layout>} />
            <Route path="/affiliated" element={<Layout><Affiliated /></Layout>} />
            <Route path="*" element={<Layout><NotFound /></Layout>} />
          </Routes>
        </BrowserRouter>
      </DataProvider>
    </TooltipProvider>
  </QueryClientProvider>
);

export default App;
